/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface TenantEntity
 */
export interface TenantEntity {
    /**
     * テナントID
     * @type {string}
     * @memberof TenantEntity
     */
    id: string;
    /**
     * AuthテナントID。
     * 認証基盤側でテナントを作成した際に採番される一意のID。
     * @type {string}
     * @memberof TenantEntity
     */
    authTenantId: string;
    /**
     * 組織ID
     * @type {string}
     * @memberof TenantEntity
     */
    organizationId: string;
    /**
     * テナント名
     * @type {string}
     * @memberof TenantEntity
     */
    name: string;
    /**
     * 作成日時
     * @type {Date}
     * @memberof TenantEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof TenantEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof TenantEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof TenantEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the TenantEntity interface.
 */
export function instanceOfTenantEntity(value: object): value is TenantEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('authTenantId' in value) || value['authTenantId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function TenantEntityFromJSON(json: any): TenantEntity {
    return TenantEntityFromJSONTyped(json, false);
}

export function TenantEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'authTenantId': json['authTenantId'],
        'organizationId': json['organizationId'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function TenantEntityToJSON(json: any): TenantEntity {
    return TenantEntityToJSONTyped(json, false);
}

export function TenantEntityToJSONTyped(value?: TenantEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'authTenantId': value['authTenantId'],
        'organizationId': value['organizationId'],
        'name': value['name'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

